import { render, staticRenderFns } from "./HelpSelectLanguage.vue?vue&type=template&id=3bf837a0"
import script from "./HelpSelectLanguage.vue?vue&type=script&lang=js"
export * from "./HelpSelectLanguage.vue?vue&type=script&lang=js"
import style0 from "./HelpSelectLanguage.vue?vue&type=style&index=0&id=3bf837a0&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf837a0')) {
      api.createRecord('3bf837a0', component.options)
    } else {
      api.reload('3bf837a0', component.options)
    }
    module.hot.accept("./HelpSelectLanguage.vue?vue&type=template&id=3bf837a0", function () {
      api.rerender('3bf837a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/HelpSelectLanguage.vue"
export default component.exports